import React from "react";
import styled, { keyframes } from "styled-components";
import { Colors } from "@blueprintjs/core";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const CommentCountStyle = styled.span`
  & .count {
    background-color: ${props => (props.muted ? Colors.GRAY4 : Colors.BLUE3)};
    color: ${props => (props.muted ? Colors.WHITE : Colors.WHITE)};
    display: inline-block;
    line-height: 0.95;
    border-radius: 0.5em;
    height: 1em;
    text-align: center;
    min-width: 1em;
    padding: 0 0.25em;
    vertical-align: middle;
    ${props =>
      props.loading &&
      `
    animation: ${rotate360} 2s linear infinite;
    `};
  }
`;

const CommentCount = props => {
  const { commentCount } = props;
  if (!commentCount) return null;
  const result = commentCount.result;
  const loading = !result;
  const count = loading ? "⌛" : result.total;
  return (
    <CommentCountStyle loading={loading} muted={loading || !(count > 0)}>
      <span className="count">{count}</span>
    </CommentCountStyle>
  );
};

export default CommentCount;



// WEBPACK FOOTER //
// ./src/app/comments/SimpleCommentCount.js